import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import uniqBy from 'lodash/uniqBy';
import { CollaborationGraph } from './collaboration-graph';
import { CONTEXT_USER_ID, MAX_CG_RESULTS, QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT } from './collaboration-graph-client';
import { extractSiteIdBySiteUrl, limitToMaxSiteUsage } from '../multi-site-utils';
var mergeUsers = function mergeUsers(prevResult, nextResult) {
  return {
    timings: Math.max(prevResult.timings, nextResult.timings),
    collaborationGraphEntities: uniqBy(prevResult.collaborationGraphEntities.concat(nextResult.collaborationGraphEntities), function (user) {
      return user.id;
    })
  };
};
var emptyUserResponse = {
  timings: 0,
  collaborationGraphEntities: []
};
export var CollaborationGraphMultiSite = /*#__PURE__*/function (_CollaborationGraph) {
  _inherits(CollaborationGraphMultiSite, _CollaborationGraph);
  var _super = _createSuper(CollaborationGraphMultiSite);
  function CollaborationGraphMultiSite(config) {
    var _this;
    _classCallCheck(this, CollaborationGraphMultiSite);
    _this = _super.call(this, {
      url: config.collaborationGraphUrl
    });
    _defineProperty(_assertThisInitialized(_this), "CONTAINER_URL_PATH", 'v1/collaborationgraph/multitenant/user/container');
    _defineProperty(_assertThisInitialized(_this), "USER_URL_PATH", 'v1/collaborationgraph/user/user');
    return _this;
  }
  _createClass(CollaborationGraphMultiSite, [{
    key: "getContainersSupplier",
    value: function () {
      var _getContainersSupplier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(arg) {
        var body, _yield$this$makeReque, result, durationMs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              body = {
                containerTypes: arg.containerTypes,
                context: {
                  principalId: CONTEXT_USER_ID,
                  siteIds: arg.cloudIds,
                  contextType: QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT
                },
                maxNumberOfResults: MAX_CG_RESULTS,
                userId: CONTEXT_USER_ID,
                expanded: true
              };
              _context.next = 3;
              return this.makeRequest(this.CONTAINER_URL_PATH, body);
            case 3:
              _yield$this$makeReque = _context.sent;
              result = _yield$this$makeReque.result;
              durationMs = _yield$this$makeReque.durationMs;
              result.collaborationGraphEntities = result.collaborationGraphEntities.map(function (cgEntity) {
                return _objectSpread(_objectSpread({}, cgEntity), {}, {
                  siteId: extractSiteIdBySiteUrl(cgEntity.containerDetails.url, arg.allSites)
                });
              });
              return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
                timings: durationMs
              }));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getContainersSupplier(_x) {
        return _getContainersSupplier.apply(this, arguments);
      }
      return getContainersSupplier;
    }()
  }, {
    key: "getUsersSupplier",
    value: function () {
      var _getUsersSupplier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(arg) {
        var _this2 = this;
        var results;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              results = arg.cloudIds.map( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cloudId) {
                  var body, _yield$_this2$makeReq, result, durationMs;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        body = {
                          context: {
                            principalId: CONTEXT_USER_ID,
                            siteId: cloudId,
                            contextType: QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT
                          },
                          maxNumberOfResults: MAX_CG_RESULTS,
                          userId: CONTEXT_USER_ID,
                          expanded: true
                        };
                        _context2.next = 3;
                        return _this2.makeRequest(_this2.USER_URL_PATH, body);
                      case 3:
                        _yield$_this2$makeReq = _context2.sent;
                        result = _yield$_this2$makeReq.result;
                        durationMs = _yield$_this2$makeReq.durationMs;
                        result.collaborationGraphEntities = result.collaborationGraphEntities.map(function (cgEntity) {
                          return _objectSpread(_objectSpread({}, cgEntity), {}, {
                            siteId: cloudId
                          });
                        });
                        return _context2.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
                          timings: durationMs
                        }));
                      case 8:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }());
              return _context3.abrupt("return", Promise.all(results).then(function (values) {
                return values.reduce(mergeUsers, emptyUserResponse);
              }));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getUsersSupplier(_x2) {
        return _getUsersSupplier.apply(this, arguments);
      }
      return getUsersSupplier;
    }()
  }, {
    key: "getUsers",
    value: function getUsers(_ref2) {
      var allSites = _ref2.allSites,
        selectedSites = _ref2.selectedSites;
      if (selectedSites.length === 0) {
        return this.usersCache.get({
          cloudIds: limitToMaxSiteUsage(allSites).map(function (site) {
            return site.cloudId;
          })
        }).value;
      } else {
        return this.getUsersSupplier({
          cloudIds: selectedSites.map(function (site) {
            return site.cloudId;
          })
        });
      }
    }
  }, {
    key: "getContainers",
    value: function getContainers(_ref3) {
      var allSites = _ref3.allSites,
        selectedSites = _ref3.selectedSites,
        containerTypes = _ref3.containerTypes;
      if (selectedSites.length === 0) {
        return this.containersCache.get({
          cloudIds: limitToMaxSiteUsage(allSites).map(function (site) {
            return site.cloudId;
          }),
          containerTypes: containerTypes
        }).value;
      } else {
        return this.getContainersSupplier({
          cloudIds: selectedSites.map(function (site) {
            return site.cloudId;
          }),
          containerTypes: containerTypes,
          allSites: allSites
        });
      }
    }
  }]);
  return CollaborationGraphMultiSite;
}(CollaborationGraph);